import {Plugins, Component} from '@packages/systems/wfdl';

import {qualify, type Qualified} from '@packages/systems/wfdl-Qualified';

import {findChild} from '@packages/utilities/platform';
import {
  isSearchResultWrapper,
  isSearchResultList,
  isSearchResultItem,
} from '@packages/utilities/elementTypeUtils';

import {type ExpressionElement} from '@packages/systems/wfdl-ast';

export const boundaryElementType: Qualified<Component.ComponentName> = qualify(
  Plugins.name('Search'),
  Component.name('SearchResultWrapper')
);

export const createBindingContextBoundary = (
  element: ExpressionElement
): Readonly<{
  boundaryType: 'startAt';
  boundaryElementId: string;
  boundaryContextVariant: 'List';
}> | null => {
  const itemId = getSearchResultItemElement(element)?.id;

  if (!itemId) {
    // corrupt node structure, so we can't really do much
    return null;
  }

  return {
    boundaryType: 'startAt',
    boundaryElementId: itemId,
    boundaryContextVariant: 'List',
  };
};

function getSearchResultItemElement(
  element: ExpressionElement
): ExpressionElement | undefined {
  if (!isSearchResultWrapper(element)) {
    return undefined;
  }
  const list = findChild(element, isSearchResultList);
  return list ? findChild(list, isSearchResultItem) : undefined;
}
